import { Modal, Table } from "antd";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const doubleColumn = [
  {
    title: "Date of freezing",
    dataIndex: "date_of_freezing",
    key: "date_of_freezing",
    render: (value) => (value ? formatDateToDDMMYYYY(value) : null),
  },
  {
    title: "Vitrification ID (Straw ID)",
    dataIndex: "vitrification_id",
    key: "vitrification_id",
  },
  {
    title: "No. of Embryo",
    dataIndex: "no_of_embryo",
    key: "no_of_embryo",
  },
  {
    title: "Stage",
    dataIndex: "stage",
    key: "stage",
  },
  {
    title: "Grade/Score",
    dataIndex: "grade_or_score",
    key: "grade_or_score",
  },
  {
    title: "Color of straw",
    dataIndex: "straw_color",
    key: "straw_color",
  },
  {
    title: "Color of Goblet",
    dataIndex: "goblet_color",
    key: "goblet_color",
  },
  {
    title: "Vitrified by",
    dataIndex: "vitrified_by",
    key: "vitrified_by",
  },
];

const EmbryoBankModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Embryo Bank Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Patient Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
                <div>Partner Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_dob}</div>
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
              </div>
            </div>
          </div>
          {activePatientJourneyModuleDetails?.length > 0 &&
            activePatientJourneyModuleDetails?.map((mainItem, index) => {
              return (
                <div className="cmn_table_wrap table_wrapper mb-2">
                  <h3 className="mt-3">
                    {" "}
                    Vitrification Details IVF ID - {mainItem?.ivf_id}
                  </h3>
                  <Table
                    columns={doubleColumn}
                    dataSource={mainItem?.embryology_data}
                    pagination={false}
                  />
                </div>
              );
            })}
        </div>
      </Modal>
    </>
  );
};

export default memo(EmbryoBankModal);
